import styled, { css } from "styled-components"
import ChevronDown from "../../svg/Chevron.svg"
import TickIcon from "../../svg/Tick.svg"

const dropdownSelectStyles = css`
  display: flex;
  align-items: center;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme: { colors }, active }) =>
    active ? colors.white : colors.grey};
  background-color: ${({ theme: { colors }, active }) =>
    active ? colors.accentBlue : colors.white};
  font-weight: ${({ theme: { fontWeight } }) => fontWeight.semiBold};
`

export const DropdownControl = styled.div`
  ${dropdownSelectStyles};
  height: 46px;
  padding: 0 20px;
  border-radius: 50px;
  box-shadow: 0 0 0 1px #949494;
  :hover,
  &.active {
    box-shadow: 0 0 0 2px #4c0ffb;
  }
`

export const DropdownItemCheck = styled(TickIcon)`
  display: ${({ active }) => (active ? "inline-block" : "none")};
`

export const DropdownContainer = styled.div`
  position: relative;
  width: 100%;
  outline: none;
  border: none;
  margin-bottom: 20px;
  :focus-visible {
    ${DropdownControl} {
      box-shadow: 0 0 0 2px #4c0ffb;
    }
  }

  &:hover {
    cursor: pointer;
  }
`

export const DropdownLabel = styled.p`
  ${({ theme: { typography } }) => typography.desktop.excerpt};
  font-weight: ${({ theme: { fontWeight } }) => fontWeight.semiBold};
  color: #636363;
`

export const DropdownControlArrow = styled.div`
  height: 46px;
  display: flex;
  align-items: center;
  margin-left: auto;
`

export const DropdownSelectMenu = styled.div`
  position: absolute;
  top: 60px;
  z-index: 999;
  display: flex;
  flex-direction: column;
  width: 100%;
  box-shadow: 2px 4px 40px rgba(19, 15, 235, 0.1);
  border-radius: 20px;
  padding: 15px 5px;
  overflow: hidden;
  background: #fff;
`

export const DropdownOption = styled.div`
  background-color: #fff;
  ${dropdownSelectStyles};
  border-radius: 3px;
  padding: 2px 15px;
  margin-bottom: 1px;
  /* add transparent border here so that the content inside won't shift on focus state */
  border: 2px solid transparent;

  span {
    width: 100%;
  }

  @media (hover: hover) {
    :hover {
      background-color: ${({ theme: { colors }, active }) =>
    active ? colors.accentBlueDarkened : colors.lightGrey};
    }
  }

  :focus-visible {
    border: 2px solid
      ${({ theme: { colors }, active }) =>
    active ? colors.accentBlueDarkened : colors.accentBlue};

    background-color: ${({ theme: { colors }, active }) =>
    active ? colors.accentBlueDarkened : colors.lightGrey};
  }
`

const ChevronStyles = css`
  width: 15px;
  stroke: ${({ theme: { colors } }) => colors.black};
`

export const ChevronDownIcon = styled(ChevronDown)`
  ${ChevronStyles};
`

export const ChevronUpIcon = styled(ChevronDown)`
  ${ChevronStyles};
  transform: rotate(180deg);
`
